<template>
  <!-- 提前还款（还款试算） -->
  <div id="calculationRepayment">
    <div class="headerStatus">
      <h3>还款试算</h3>

    </div>
    <div class="amountStatus">
      <span class="styleMoney">¥</span>
      <input
        class="styleInput"
        @blur="blurChange"
        v-model="waitprincipal"
        type="number"
        ref="myInput"
        :placeholder="placeholderAmt"
        :disabled="inputDisabled"
        :autofocus="autofocus"
      />
      <img
        class="btnImg"
        src="@/assets/images/jilu.png"
        alt=""
      />
    </div>
    <p>{{elementData.title}}</p>
    <ul>
      <component
        v-for="(app, index) in elementData.components"
        :is="app.component"
        :obj="app"
        :key="index"
        @monitors="monitors"
      />
    </ul>
    <Button
      :text="draw"
      :type="danger"
      class="nextStep"
      :click="sureRepayment"
      :loading="isLoading"
      :disabled="canGoNext"
    />
    <PageLoading :pageLoading="pageLoading" />
  </div>
</template>
<script>
import { mapState, mapMutations } from 'vuex';
import { getIPaddressAndwechatAccessLocation } from '@/utils/index';
import { Toast, Dialog, } from 'vant';
import PageLoading from '@/components/PageLoading.vue';
import Button from '@/components/Button.vue';
import Select from './components/Select.vue';
import DataItem from './components/DataItem.vue';

export default {
  name: 'calculationRepaymentStandard',
  components: {
    PageLoading,
    Button,
    Select,
    DataItem,
  },
  data() {
    return {
      danger: 'danger',
      draw: '确认还款',
      autofocus: false,
      inputDisabled: true, // 默认禁用输入框
      isLoading: false, // 默认启用还款按钮
      waitprincipal: '', // 输入金额
      placeholderAmt: '', // 还款试算输入框默认值
      // availableBalance: '', // 账户可用余额
      selectCompArry: {}, // 动态计算页面选择器组件个数
      elementData: {}, // 组件配置项
      echoInfo: {},
      pageLoading: false,
    };
  },
  mounted() {
    getIPaddressAndwechatAccessLocation();
    this.initPage();
  },
  computed: {
    ...mapState({
      otherPages(val) {
        return val.otherPages;
      },
    }),
    // 是否可点击确认还款
    canGoNext() {
      // no-extra-boolean-cast
      if (!this.waitprincipal) {
        return true;
      }
      if (this.waitprincipal === '0.00' || this.waitprincipal === '0' || this.waitprincipal === '0.0') {
        return true;
      }

      if (this.isLoading) {
        return true;
      }
      return false;

      // 还款方式为部分提前还款时，输入金额不能大于剩余总金额 - 暂时屏蔽
      // else if (this.selectCompArry.repaymentMethod === '3' && parseFloat(this.waitprincipal) > parseFloat(this.availableBalance)) {
      //   return true;
      // }
    },
  },
  watch: {
  },
  methods: {
    ...mapMutations('otherPages', ['updateForm']),
    initPage() {
      this.updateForm({
        drawId: localStorage.getItem('drawId'),
        orderId: localStorage.getItem('orderId'),
      });

      this.getPageConfig();
      setTimeout(() => {
        this.pageLoading = false;
      }, 20000);
    },
    // 确认还款
    sureRepayment() {
      // const productId = window.location.search.split('&')[0].split('=')[1];
      const { productId } = this.$route.query;
      console.log('1111111-------', productId);
        try {
          this.isLoading = true;
          this.$api.OtherPage.commitApply(
            {
              drawId: localStorage.getItem('drawId'),
              orderId: localStorage.getItem('orderId'),
              rePayAmt: this.waitprincipal,
              pageId: this.$route.query.pageId,
              ...this.selectCompArry,
              ...this.echoInfo,
            },
          ).then((res) => {
            if (res.success) {
              const toast = Toast.loading({
                duration: 0, // 持续展示 toast
                forbidClick: true,
                message: '还款中... 3 s',
              });
              let second = 3;
              const timer = setInterval(() => {
                second--;
                if (second) {
                  toast.message = `还款中... ${second} s`;
                } else {
                  clearInterval(timer);
                  // 手动清除 Toast
                  Toast.clear();
                  this.$router.push('/supermarket/v2/myload');
                }
              }, 1000);
            } else {
              Toast(res.returnMessage);
              this.isLoading = false;
            }
          });
        } catch (e) {
          console.log('e--------', e);
          Toast('还款失败');
          this.isLoading = false;
        }
    },

    // 获取页面配置
    getPageConfig() {
      this.$toast.loading({
        message: '加载中...',
        clear: true,
        forbidClick: true,
        loadingType: 'spinner',
      });
      this.$api.PublicPage.getProductConfig({
        productId: this.$route.query.productId,
        pageId: this.$route.query.pageId,
      }).then((res) => {
        if (res.success) {
          const result = JSON.parse(res.data[0].productConfigs)[0];
          this.elementData = result;
          // this.elementData = [{"components": [{"values": [{"text": "只还当期","value": "2"},{"text": "全部还款","value": "1"}],"component": "Select","key": "repaymentMethod","label": "还款方式","placeholder": "请选择还款方式"},{"component": "DataItem","key": "repayCardNo","label": "还款账号"},{"component": "DataItem","key": "repayCardName","label": "还款账户名称"},{"component": "DataItem","key": "repayAcctAmt","label": "账户余额","firstUnit": "￥"},{"component": "DataItem","key": "repayAcctUseableAmt","label": "账户可用余额","firstUnit": "￥"},{"component": "DataItem","key": "dueTotalAmt","label": "应还总额","firstUnit": "￥"},{"component": "DataItem","key": "remandTotalPrincp","label": "应还本金","firstUnit": "￥"},{"component": "DataItem","key": "remandTotalInt","label": "应还利息","firstUnit": "￥"},{"component": "DataItem","key": "remandTotalFine","label": "应还罚息","firstUnit": "￥"},{"component": "DataItem","key": "remandTotalCint","label": "应还复息","firstUnit": "￥"}],"title": "还款金额"}][0];
          const flag = this.elementData.components.some((v) => v.component === 'Select');
          // 如果没有Select组件，进入页面调用回显接口，并将输入框改成不禁用的
          if (!flag) {
            this.repayTrial();
            this.inputDisabled = false;
          }
        }
        this.$toast.clear();
      });
    },

    // 试算 - 试算成功将isBtn按钮置成true
    async repayTrial() {
      try {
        this.pageLoading = true;
        const { data, success, returnMessage } = await this.$api.OtherPage.queryEchoInfo(
          {
            drawId: localStorage.getItem('drawId'),
            orderId: localStorage.getItem('orderId'),
            rePayAmt: this.waitprincipal,
            pageId: this.$route.query.pageId,
            ...this.selectCompArry,
          },
        );
        if (success) {
          this.echoInfo = data;
          for (const i in this.elementData.components) {
            this.$set(this.elementData.components[i], 'value', data[this.elementData.components[i].key]);
          }
          this.waitprincipal = data.dueTotalAmt;
          this.pageLoading = false;
          // this.availableBalance = data.dueTotalAmt;
        } else {
          Toast(returnMessage);
        }
      } catch (e) {
        Toast('还款试算接口异常');
      }
    },

    // 初始化页面展示数据
    initData() {
      for (const i in this.elementData.components) {
        this.$set(this.elementData.components[i], 'value', '');
      }
      this.waitprincipal = '';
      // this.waitprincipal = this.selectCompArry.repaymentMethod === '3' ? this.availableBalance : ''; // 设置默认金额
    },

    // 动态组件事件监听
    monitors(obj, e) {
      if (Object.keys(this.selectCompArry).length === 0) {
        // 计算选择器组件个数，判断所有选择器组件都有值后再调用接口 -- 进入页面组件初始化值
        for (const i in this.elementData.components) {
          if (this.elementData.components[i].component === 'Select') {
            this.selectCompArry[this.elementData.components[i].key] = '';
          }
        }
      }

      // 选择器组件赋值
      for (const key in this.selectCompArry) {
        if (obj.key === key) {
          this.selectCompArry[key] = e.value;
        }
      }
      console.log(this.selectCompArry, '==selectCompArry');
      if (this.selectCompArry.repaymentMethod === '3') {
        this.placeholderAmt = '请输入金额';
        this.inputDisabled = false;
      } else {
        this.inputDisabled = true;
        this.placeholderAmt = '';
      }
      this.initData();
      this.toMatch();
    },

    // 判断试算条件是否齐全，进行试算
    toMatch() {
      let t = 0;
      for (const key in this.selectCompArry) {
        // 将动态组件值传入vuex
        this.$store.state.otherPages[key] = this.selectCompArry[key];
        if (this.selectCompArry[key]) {
          t += 1;
        }
      }
      if (Object.keys(this.selectCompArry).length === t) {
        if (this.selectCompArry.repaymentMethod === '3' && !this.waitprincipal) { // 部分提前还款并且金额为空不进行试算
          return false;
        }
        this.repayTrial();
      }
    },

    // 金额失去焦点
    blurChange() {
      const VALIATEREGTWO = /^([1-9]\d*|0)(\.\d{0,2})?$/;
      const VALIATEREGONE = /^[+]{0,1}(\d+)$|^[+]{0,1}(\d+\.\d+)$/;
      if (this.waitprincipal === '') {
        Toast('还款金额不能为空');
        return;
      }
      if (!this.waitprincipal) {
        Toast('还款金额不能为0');
        return;
      }
      if (!VALIATEREGONE.test(this.waitprincipal)) {
        Toast('还款金额只支持数字输入');
        return;
      }

      if (!VALIATEREGTWO.test(this.waitprincipal)) {
        Toast('还款金额只支持二位小数');
        return;
      }

      // if (Number(this.waitprincipal) > Number(this.availableBalance)) {
      //   Toast('待还金额不能大于应还本金');
      //   return;
      // }
      this.toMatch();
    },
  },
};
</script>
<style scoped>
#calculationRepayment {
  width: 100%;
  height: 100%;
  background: #fff;
}
.infoList {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  width: 90%;
  height: 50px;
  margin: 0 auto;
}
.infoListLeft {
  color: #7d828e;
  font-size: 14px;
}
.infoListRight {
  color: #000;
  font-size: 14px;
}
.nextStep {
  margin-top: 30px;
}
.styleInput {
  width: 120px;
  height: 27px;
  font-size: 22px;
  font-family: PingFangSC-Medium;
  color: #f65846;
  font-weight: bold;
  border: 0;
  margin-right: 10px;
}
.styleMoney {
  font-size: 22px;
  font-family: PingFangSC-Medium;
  color: #f65846;
  margin-right: 3px;
}
.amountStatus {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  margin: 16px 0;
}
.btnImg {
  width: 17px;
  height: 17px;
}
.headerStatus {
  position: relative;
}
.headerStatus p {
  margin: 0;
  padding: 0;
  font-size: 14px;
}
.headerStatus h3 {
  margin: 0;
  padding-top: 16px;
  font-size: 18px;
}
input::-webkit-input-placeholder {
  color: rgb(202, 198, 198);
}
input::-moz-placeholder {
  /* Mozilla Firefox 19+ */
  color: rgb(202, 198, 198);
}
input:-moz-placeholder {
  /* Mozilla Firefox 4 to 18 */
  color: rgb(202, 198, 198);
}
input:-ms-input-placeholder {
  /* Internet Explorer 10-11 */
  color: rgb(202, 198, 198);
}
input:disabled {
  background: transparent;
}
</style>
